import * as React from 'react';
import Typography from '@mui/material/Typography';
import BasicModal from '../Modal';
import { Alert, FormControl, InputAdornment, TextField } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { updateUser } from 'APIs/AuthApi';
import Loader from 'components/atoms/loader';

interface ISubscriptionPriceModalProps {
  children: JSX.Element;
}

const SubscriptionPriceModal = ({ children }: ISubscriptionPriceModalProps) => {
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [priceError, setPriceError] = React.useState(false);
  const [price, setPrice] = React.useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authState = useAppSelector(selectAuth);

  const submitPrice = async () => {
    try {
      if (authState.id) setLoading(true);
      if (price === '') {
        setPriceError(true);
        setSuccess(false);
        setLoading(false);
        return;
      }
      await updateUser({ id: authState.id, subscriptionPrice: price });
      setError(false);
      setPriceError(false);
      setSuccess(true);
    } catch (error) {
      setError(true);
      setSuccess(false);
      setPriceError(false);
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <BasicModal open={open} handleClose={handleClose}>
        <>
          <Typography
            sx={{ textAlign: 'center', color: 'white' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Set Subscription Price
          </Typography>
          {success && (
            <Alert
              sx={{ marginTop: '10px' }}
              onClose={() => setSuccess(false)}
              severity="success"
            >
              Subscription price has been set successfully.
            </Alert>
          )}
          {error && (
            <Alert
              sx={{ marginTop: '10px' }}
              onClose={() => setError(false)}
              severity="error"
            >
              There was an error in setting subscription price.
            </Alert>
          )}
          {priceError && (
            <Alert
              sx={{ marginTop: '10px' }}
              onClose={() => setPriceError(false)}
              severity="error"
            >
              Please enter a price to set.
            </Alert>
          )}
          <Typography
            sx={{ textAlign: 'center', marginY: '30px' }}
            variant="h6"
            component="h3"
          >
            <FormControl>
              <TextField
                placeholder="0.00"
                required
                sx={{
                  input: {
                    color: 'white',
                    fontSize: '18px',
                    maxWidth: '100px',
                    paddingX: '10px',
                  },
                }}
                onChange={e => setPrice(e.target.value)}
                id="input-with-icon-textfield"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <span style={{ color: 'white', fontSize: '18px' }}>
                        USD
                      </span>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                color="info"
              />
            </FormControl>
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ my: 4, textAlign: 'center', opacity: '0.6' }}
          >
            Note: we will use a a spot price at the time when your supporter
            subscribes. The amount you will recieve in cryptocurrencies can
            fluctuate.
          </Typography>
          <NormalButton
            text={loading ? <Loader size="1.4" /> : 'Set Price'}
            color="yellow"
            sx={{ width: '100%', textTransform: 'uppercase' }}
            onClick={submitPrice}
          />
        </>
      </BasicModal>
    </div>
  );
};

export default SubscriptionPriceModal;
